import { getOrganizations } from "../api/organizations/organizationsApi";
let wildXROrgId: string | null = null;

export async function fetchWildXROrgId(): Promise<void> {
  if (!wildXROrgId) {
    try {
      const organizations = await getOrganizations();
      const wildXR = organizations.find((org: any) => org.name === "WildXR");
      wildXROrgId = wildXR.organizationId;
    } catch (error) {
      console.error("Error fetching WildXR organization ID:", error);
    }
  }
}

export function getWildXROrgId(): string | null {
  return wildXROrgId?.toLocaleLowerCase() || null;
}
